// removed by extract-text-webpack-plugin
module.exports = {"Container":"DeleteVacc__Container__1w9Hd","Btn":"DeleteVacc__Btn__1T-Wn","RedBtn":"DeleteVacc__RedBtn__3jaLH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VaccinationController/DeleteVacc/DeleteVacc.css
// module id = 126
// module chunks = 0